<!-- <div id="loding" [ngClass]="{ 'loding-hide': lodingImage }">
  <img src="assets/img/loding.gif" />
</div> -->
<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12 headboxes">
        <div class="card p-0">
          <div class="card-block p-0">
            <div class="heading-box">
              <div class="row align-items-center">
                <div class="col-md-3">
                  <div class="pagename">
                    <h3 class="card-title">Countries</h3>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="total-count">
                    <h5 class="m-0">Total</h5>
                    <h2>{{ countryListTotal ? countryListTotal :'0' }}</h2>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="addbtn">
                    <button
                      id="add_btn"
                      type="button"
                      class="btn btn-primary addbtn"
                      (click)="open(content)"
                      style="float: right"
                    >
                      Add Country
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="card">
          <div class="card-block">
            <div class="table-responsive">
               <table
                datatable
                id="country_tab"
               [dtOptions]="dtOptions"
                [dtTrigger]="dtTrigger"
                class="table"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#Sl</th>
                    <th>Country Name</th>
                    <th>Alias</th>
                    <th>Created By</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody *ngIf="countryList?.length != 0">
                  <tr
                    *ngFor="let item of countryList; let i = index"
                    [attr.data-index]="i"
                  >
                    <td>{{ getRowNumber(i) }}</td>
                    <td>{{ item.country_name }}</td>
                    <td>{{ item.sortname }}</td>
                    <td>
                      <span *ngIf="item.created_by_name == 'admin'"
                        >WEP-Admin</span
                      >
                      <span *ngIf="item.created_by_name != 'admin'">{{
                        item.created_by_name
                      }}</span>
                    </td>
                    <td>
                      <span
                        *ngIf="item.is_active == 'Y'"
                        class="badge badge-success font-weight-normal badge-pill"
                        >Active</span
                      >
                      <span
                        *ngIf="item.is_active == 'N'"
                        class="badge badge-danger badge-pill"
                        >Inactive</span
                      >
                    </td>
                    <td class="action">
                      <label class="switch">
                        <input
                          type="checkbox"
                          (change)="delete(item)"
                          [checked]="item.is_active === 'Y'"
                        />
                        <span class="slider round"></span>
                      </label>

                      <button
                        type="button"
                        class="btn text-dark btn-sm rounded bg-light"
                        (click)="edit(this.countryList[i].id, content)"
                      >
                        <i class="fa fa-edit"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>

                     <tbody *ngIf="countryList?.length == 0">
                  <tr>
                    <td colspan="6" class="no-data-available text-center">
                      No data available!
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #content let-c="close" let-d="dismiss" id="customer-add">
      <div class="modal-info" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ modalTitle }}</h4>
            <button
              type="button"
              class="close"
              aria-label="Close"
              (click)="d('Cross click')"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <alert>
              <div class="alert alert-danger"><a class="close">×</a></div>
            </alert>
            <form
              method="post"
              enctype="multipart/form-data"
              class="form-horizontal"
              #f="ngForm"
            >
              <div class="form-group row">
                <label for="country_name" class="col-md-12 col-form-label"
                  >Country Name <span>*</span></label
                >
                <div class="col-md-12">
                  <input
                    class="form-control"
                    type="text"
                    id="country_name"
                    name="country_name"
                    required
                    [(ngModel)]="country.country_name"
                    pattern="[A-Za-z ]*"
                  />
                  <span
                    *ngIf="isSubmitted && isFieldsInvalid(country.country_name)"
                    class="alert-block"
                    >This field is required</span
                  >
                  <span
                    *ngIf="f.controls.country_name?.errors?.pattern"
                    class="alert-block"
                    >Invalid country name</span
                  >
                </div>
              </div>

              <div class="form-group row">
                <label for="sortname" class="col-md-12 col-form-label"
                  >Short Name <span>*</span></label
                >
                <div class="col-md-12">
                  <input
                    class="form-control"
                    type="text"
                    id="sortname"
                    name="sortname"
                    required
                    [(ngModel)]="country.sortname"
                    pattern="[A-Za-z ]*"
                  />
                  <span
                    *ngIf="isSubmitted && isFieldsInvalid(country.sortname)"
                    class="alert-block"
                    >This field is required</span
                  >
                  <span
                    *ngIf="f.controls.sortname?.errors?.pattern"
                    class="alert-block"
                    >Invalid sort name
                  </span>
                </div>
              </div>

              <div class="form-group row">
                <label for="phonecode" class="col-md-12 col-form-label"
                  >Phone Code <span>*</span></label
                >
                <div class="col-md-12">
                  <input
                    class="form-control"
                    type="text"
                    maxlength="5"
                    id="phonecode"
                    name="phonecode"
                    required
                    [(ngModel)]="country.phonecode"
                    maxlength="5"
                    pattern="^[0-9]*$"
                  />
                  <span
                    *ngIf="
                      isSubmitted &&
                      (country.phonecode == undefined ||
                        country.phonecode == '')
                    "
                    class="alert-block"
                    >This field is required</span
                  >
                  <span
                    *ngIf="f.controls.phonecode?.errors?.pattern"
                    class="alert-block"
                    >Invalid phone code</span
                  >
                </div>
              </div>

              <div class="form-group row">
                <label for="is_active" class="col-md-12 col-form-label"
                  >Status</label
                >
                <div class="col-md-12">
                  <select
                    class="form-control"
                    id="is_active"
                    name="is_active"
                    [(ngModel)]="country.is_active"
                  >
                    <option value="Y">Active</option>
                    <option value="N">Inactive</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary d-none"
              aria-label="Close"
              (click)="d('Cross click')"
            >
              Close
            </button>
            <button
              type="submit"
              class="btn btn-primary rounded savebtn"
              (click)="save(this.country, f)"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
